import { Grain } from "./shared";

export const VibeBand = () => (
  <section
    data-testid="atmosphere-section"
    className="relative w-full py-24 px-6 md:px-12 overflow-hidden text-white bg-[#12082A]"
  >
    <Grain id="g-vibe" />
    <div className="relative z-10 max-w-4xl mx-auto text-center">
      <span className="mono-lbl text-xs uppercase text-[#2DE2E6] font-bold">Our Mission</span>
      <h2 className="display-type text-4xl md:text-6xl uppercase font-black my-4">
        Hiring People With a Disability
      </h2>
      <p className="text-base md:text-lg text-white/90 max-w-xl mx-auto leading-relaxed">
        Ever had a job where you felt like you weren&apos;t valued as a human with a disability?
        People with all kinds of disabilities are welcome to come volunteer and see if they like
        working in a very cool coffee shop with retro video games — a place run by people with
        disabilities. Come check us out and see what we&apos;re all about.
      </p>
      <p className="text-sm font-bold text-[#2DE2E6] mt-4">
        We round all change to help with suicide awareness.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
        <a
          data-testid="job-application-link"
          href="https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/8cf1524065f0075e_disability_coffee_shop_application.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-4 rounded-xl bg-[#FF2E88] text-white font-bold text-sm uppercase mono-lbl hover:bg-[#D61F73] transition-colors"
        >
          Job Application
        </a>
        <a
          data-testid="volunteer-application-link"
          href="https://customer-assets-0z36b82j.emergentagent.net/job_joystick-java/artifacts/c2212fe37dcb3c35_disability_inclusive_volunteer_application.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-4 rounded-xl bg-[#2DE2E6] text-[#12082A] font-bold text-sm uppercase mono-lbl hover:bg-[#1fc4c8] transition-colors"
        >
          Volunteer Application
        </a>
      </div>
    </div>
  </section>
);
